import styled from 'styled-components';

export const IconWrapper = styled.div`
    position: absolute;
    right: 10px;
    top: 3px;
`;
